import { useCustom } from "@refinedev/core";
import { TransferToken } from "types/";

interface UseGetTransferTokenOptions {
  enabled?: boolean;
}

// Transfer tokens expire after 120s, so refresh every 60s to stay ahead
const TOKEN_REFRESH_INTERVAL = 60 * 1000; // 60 seconds

export default function useGetTransferToken(
  options: UseGetTransferTokenOptions = {}
) {
  const { enabled = true } = options;

  const { data, isLoading, refetch } = useCustom<TransferToken>({
    url: `api/tokens/transfer`,
    method: "post",
    errorNotification: false,
    queryOptions: {
      enabled,
      // Auto-refresh token before expiration
      refetchInterval: enabled ? TOKEN_REFRESH_INTERVAL : false,
      // Refetch on window focus to ensure fresh token
      refetchOnWindowFocus: true,
      // Don't cache stale tokens
      staleTime: 0,
      // retry 3 times to not miss WS messages for too long
      retry(failureCount, error) {
        console.error("Failed to get transfer token:", error);
        return failureCount < 3;
      },
    },
  });

  return { transferToken: data?.data, isLoading, refetch };
}
